<template>
    <div>
        <HomeOutlet v-if="isHomeOutlet" v-on:gotodetailoutlet="showdetailoutlet" v-on:dataoutlet="showdataoutlet"
                    v-on:gotodetailoutletnonaktif="showdetailoutletnonaktif"
                    v-on:gotodetailworkshopnonaktif="showdetailworkshopnonaktif"
                    v-on:showdataworkshop="showdataworkshop" v-on:showdetailworkshop="showdetailworkshop"
                    ref="getoutletnon" :statusoutletfilter="statusoutletfilter"
                    :statusworkshopfilter="statusworkshopfilter"
        />
        <DataOutlet v-if="isDataOutlet" v-on:showProductionProcess="showpruductionprocess"
                    v-bind:dataDataOutlet="dataDataOutlet"
                    v-on:golistoutlet="showlistoutletworkshop"/>
        <ProductionProcess v-if="isProductionProcess" v-on:cekinternet="cekconnection" v-on:selectPage="selectPage"
                           v-on:selectfromModal="selectfromModal" v-on:showDataOutlet="showdataoutlet"
                           v-bind:dataProductionActivity="dataProductionActivity"
                           v-bind:dataProductionProses="dataPoductionProses"/>
        <ProductionActivity v-if="isProductionActivity" v-on:showProductionProcess="showpruductionprocess"
                            v-on:PostProductionActivity="PostActivity"
                            v-on:PostProductionActivityElse="PostActivityElse"
                            v-bind:dataProductionActivity="dataProductionActivity"
                            v-bind:Pilih_Jenis="pilih_jenisOutlet" v-bind:menuoutlet="menu_Outlet"
                            v-bind:dataProductionProses="dataPoductionProses"
                            v-on:showproductionpalace="showproductionplace"/>
        <ProductionPlace v-if="isProductionPlace" v-on:showProductionProcess="showpruductionprocess"
                         v-bind:dataProductionPlace="dataProductionPlace" v-on:Activity="showproductionactivity"/>
        <DetailOutlet v-if="isDetailOutlet" v-on:gotolist="showlistoutletworkshop"
                      v-bind:datalistoutlet="datalistoutlet" ref="detailoutletref"/>
        <DetailOutletNonaktif v-if="isDetailOutletNonaktif" v-on:golistoutletnonaktif="showlistoutletnonaktif"
                              v-bind:datalistoutlet="datalistoutlet"/>
        <DetailWorkshopNonaktif v-if="isDetailWorkshopnonaktif" v-on:golistworkshopnonaktif="showlistworkshopnonaktif"
                                v-bind:datalistworkshop="dataidworkshop"/>
        <DataWorkshop v-if="isDataWorkshop" v-bind:dataDataWorkshop="dataDataWorkshop"
                      v-on:backtolist="showlistoutletworkshop"
                      v-on:showProductionWorkshop="showpruductionworkshop"/>
        <ProductionWorkshop v-if="isProductionWorkshop" v-bind:dataProductionWorkshop="dataProductionWorkshop"
                            v-bind:dataDataWorkshop="dataDataWorkshop" v-on:showdetailworkshop="showdetailworkshop"
                            @showdataworkshopFromProd="showdataworkshop"/>
        <DetailWorkshop v-if="isDetailWorkshop" v-bind:datalistworkshop="dataidworkshop" ref="detailworkshopref"
                        v-on:goToOutlet="workshopToOutlet"
                        v-on:gotolist="showlistoutletworkshop"
                        @TahapanWorkshop=""/>
        <SetTahapanWorkshop v-if="isSetTahapanWorkshop"/>
        <div id="loadingPage">
            <span class="spinner-border spinner-border-sm-loader" role="status" aria-hidden="true"></span>
        </div>
    </div>
</template>

<script>
    import HomeOutlet from "./onboarding/HomeOutlet";
    import DataOutlet from "./onboarding/DataOutlet";
    import ProductionProcess from "./onboarding/ProductionProcess";
    import ProductionActivity from "./onboarding/ProductionActivity";
    import ProductionPlace from "./onboarding/ProductionPlace";
    import DetailOutlet from "./onboarding/DetailOutlet";
    import DetailOutletNonaktif from "./Outlet/Detail Outlet Nonaktif/DetailOutletNonaktif";
    import DataWorkshop from "./onboarding/Create Workshop/DataWorkshop";
    import ProductionWorkshop from "./onboarding/Create Workshop/ProductionWorkshop";
    import DetailWorkshop from "./onboarding/Create Workshop/DetailWorkshop";
    import SetTahapanWorkshop from "./onboarding/Create Workshop/SetTahapanWorkshop";
    import DetailWorkshopNonaktif from "./Outlet/Detail Workshop Nonaktif/DetailWorkshopNonaktif";

    export default {
        name: "AddOutlet",
        components: {
            SetTahapanWorkshop,
            DetailWorkshop,
            ProductionWorkshop,
            DataWorkshop,
            DetailWorkshopNonaktif,
            DataOutlet, ProductionProcess, ProductionActivity, ProductionPlace, DetailOutlet, HomeOutlet,
            DetailOutletNonaktif,
        },
        data() {
            return {
                idoutlet: "",
                isDataOutlet: false,
                isProductionProcess: false,
                isProductionActivity: false,
                isProductionPlace: false,
                isHomeOutlet: false,
                isDetailOutlet: false,
                isDetailOutletNonaktif: false,
                isDataWorkshop: false,
                isProductionWorkshop: false,
                isDetailWorkshop: false,
                isSetTahapanWorkshop: false,
                isDetailWorkshopnonaktif: false,
                parentidoutlet: '',

                datalistoutlet: {
                    idoutlet: '',
                },

                dataidworkshop: {
                    idworkshop: ''
                },

                dataPoductionProses: {
                    isClicked: false,
                    inputradio: '',
                    jenisworkshop: '',
                    workshop: {},
                },
                dataDataOutlet: {
                    selectedkota: '',
                    optionskota: [],
                    nameOutlet: '',
                    isClicked: false,
                    alamat: '',
                    telp: '',
                    logourl: '',
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                },
                dataProductionPlace: {
                    selectedkota: '',
                    optionskota: [],
                    namaworkshop: '',
                    alamatworkshop: '',
                    telpworkshop: '',
                    isClicked: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }

                },
                dataProductionActivity: {
                    dataTahapan: [],
                    checklisttahapan: [8000],
                    isClicked: false,
                },

                dataDataWorkshop: {
                    telp: '',
                    selectedkota: '',
                    optionskota: [],
                    Alamat: '',
                    nama: '',

                },

                dataProductionWorkshop: {
                    dataTahapan: [],
                    checklisttahapan: [8000],
                    isClicked: false,
                },

                pilih_jenisOutlet: "",
                menu_Outlet: '',
                requestHeaders: {
                    headers: {
                        'Authorization': 'Bearer ' + localStorage.getItem('token'),
                    }
                },

                statusoutletfilter: 0,
                statusworkshopfilter: 0,
            }
        },
        mounted() {
            this.idoutlet = this.$route.params.idoutlet;
            if (this.idoutlet != undefined) {
                this.showdetailoutlet(this.idoutlet)
            } else {

                if (this.$route.query.part != "" && this.$route.query.part != undefined) {
                    if (this.$route.query.part == "outlet") {
                        if (this.$route.query.id != "" && this.$route.query.id != undefined) {
                            this.showdetailoutlet(this.$route.query.id)
                        }
                    }
                } else {
                    this.showlistoutletworkshop();
                }
                this.getTahapan();
            }
            $('#newworkshop').hide();
            $('#shameworkshop').hide();

        },
        methods: {
            hashworkshop() {
                this.$refs.getoutletnon.changeStatusTabsworkshop();
                this.$refs.getoutletnon.getWorkshop();
                this.$refs.getoutletnon.getOutlet();
            },

            showdataworkshop(cleardata = true) {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = true;
                this.isDataWorkshop = true;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
                $('#homeoutletworkshop').hide();

                if (cleardata) {
                    this.clearDataAddWorkshop()
                }
            },

            showpruductionworkshop() {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = true;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = true;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
                $('#homeoutletworkshop').hide();
            },

            showlistoutletworkshop(page = "outlet") {
                this.clearDataAddOutlet()
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isDetailOutletNonaktif = false;
                this.isHomeOutlet = true;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
                if (page === 'workshop') {
                    setTimeout(() => {
                        $("#nav-profile-tab").click();
                        $("#homeoutletworkshop").show();
                        this.$refs.getoutletnon.getWorkshop();
                    }, 100)
                }
            },
            showproductionactivity() {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = true;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;

            },
            showproductionplace(refresh = false) {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = true;
                this.isDetailOutlet = false;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;

                // if (refresh) {
                //     this.dataProductionActivity.checklisttahapan = ["8000"]
                //     this.pilih_jenisOutlet = ""
                //     this.dataPoductionProses = {
                //         isClicked:false,
                //         inputradio:'',
                //     }
                // }
            },

            showdetailoutlet(idoutlet) {
                this.datalistoutlet.idoutlet = idoutlet;
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
                this.isDetailOutlet = true;
                this.$refs.detailoutletref.cekOnboardingLayanan()
                this.smartTrackingClick("detail_outlet");

            },

            showdetailoutletnonaktif(idoutlet) {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isDetailOutletNonaktif = true;
                this.isHomeOutlet = true;
                this.datalistoutlet.idoutlet = idoutlet;
                $('#homeoutletworkshop').hide();
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
            },

            showlistoutletnonaktif() {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isDetailOutletNonaktif = false;
                this.isHomeOutlet = true;
                $('#homeoutletworkshop').show();
                this.$refs.getoutletnon.getOutletnonaktif();
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
            },

            showlistworkshopnonaktif() {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isDetailOutletNonaktif = false;
                this.isDetailWorkshopnonaktif = false;
                this.isHomeOutlet = true;
                $('#homeoutletworkshop').show();
                this.$refs.getoutletnon.getWorkshop();
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;

                this.statusoutletfilter = 0;
            },

            showdetailworkshopnonaktif(idworkshop) {
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isDetailOutletNonaktif = false;
                this.isDetailWorkshopnonaktif = true;
                this.isHomeOutlet = true;
                this.dataidworkshop.idworkshop = idworkshop;
                $('#homeoutletworkshop').hide();
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
            },


            showdataoutlet() {
                this.isDataOutlet = true;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
            },
            showpruductionprocess() {
                this.isDataOutlet = false;
                this.isProductionProcess = true;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;

                // this.dataProductionPlace = {
                //     selectedkota: '1',
                //         optionskota: [],
                //         namaworkshop:'',
                //         alamatworkshop:'',
                //         telpworkshop:'',
                //         isClicked:false,
                //         requestHeaders: {
                //         headers: {
                //             'Authorization': 'Bearer ' + localStorage.getItem('token'),
                //         }
                //     }
                //
                // }
            },

            showdetailworkshop(idworkshop) {
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = true;
                this.isSetTahapanWorkshop = false;
                this.dataidworkshop.idworkshop = idworkshop;
                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = false;
                this.isHomeOutlet = false;
                // $('#homeoutletworkshop').hide();
                // this.$refs.detailworkshopref.getDetailWorkshop(idworkshop);
                this.smartTrackingClick("detail_workshop");

            },


            selectPage(pilih_jenisOutlet) {
                this.pilih_jenisOutlet = pilih_jenisOutlet;
                if (pilih_jenisOutlet === "ya") {
                    this.showproductionactivity()
                } else if (pilih_jenisOutlet === "tidak") {
                    if (this.menu_Outlet === 'new') {
                        this.showproductionplace()
                    } else if (this.menu_Outlet === 'same_WK') {
                        this.nonePost()
                    } else {
                        this.nonePost()
                    }
                }
            },
            selectfromModal(menu_outlet) {
                this.menu_Outlet = menu_outlet

            },

            async cekconnection(payload) {
                $('#BtnProses').prop('disabled', true);
                this.dataPoductionProses.isClicked = true
                $('#textBtnProses').hide();
                try {
                    this.smartTrackingClick("add_outlet_step3_"+payload.pilih_jenisOutlet);

                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/cek_koneksi', this.requestHeaders)
                    if (response.status === 200) {
                        $('#BtnProses').prop('disabled', false);
                        this.dataPoductionProses.isClicked = false
                        $('#textBtnProses').show();
                        if (response.data.status === true) {
                            this.pilih_jenisOutlet = payload.pilih_jenisOutlet
                            this.dataPoductionProses.inputradio = this.pilih_jenisOutlet
                            this.dataPoductionProses.jenisworkshop = this.menu_Outlet;
                            this.dataPoductionProses.workshop = payload.workshop
                            if (this.pilih_jenisOutlet === "ya") {
                                if (this.menu_Outlet === "new") {
                                    this.showproductionactivity()
                                } else if (this.menu_Outlet === "shameWK") {
                                    this.gabungkanWorkshopExisting(payload.workshop.idworkshop);
                                }
                            } else if (this.pilih_jenisOutlet === "tidak") {
                                if (this.menu_Outlet === "new") {
                                    this.showproductionplace()
                                } else if (this.menu_Outlet === "shameWK") {
                                    this.nonePost();
                                }
                            } else {
                                this.$toast.error("Isi pilihan proses produksi terlebih dahulu")
                            }
                        } else {
                            this.$toast.error(response.data.msg)
                            $('#BtnProses').prop('disabled', false);
                            this.dataPoductionProses.isClicked = false
                            $('#textBtnProses').show();
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    $('#BtnProses').prop('disabled', false);
                    this.dataPoductionProses.isClicked = false
                }
            },

            async nonePost() {
                this.dataProductionActivity.isClicked = true
                try {
                    const dataoutlet = new FormData
                    dataoutlet.append('nama_outlet', this.dataDataOutlet.nameOutlet)
                    dataoutlet.append('telp', this.dataDataOutlet.telp_code + this.dataDataOutlet.telp)
                    dataoutlet.append('alamat', this.dataDataOutlet.alamat)
                    dataoutlet.append('kota', this.dataDataOutlet.selectedkota)
                    dataoutlet.append('logo_url', this.dataDataOutlet.logourl)
                    dataoutlet.append('idowner', localStorage.getItem('idowner'))
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/create_outlet', dataoutlet, this.requestHeaders, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    )
                    // this.dataProductionActivity.isClicked= false
                    // $('#textBtn2').hide();
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.skipOnboarding(1, res.data.data.idoutlet)
                            this.dataProductionActivity.isClicked = false
                            this.dataDataOutlet.nameOutlet = '';
                            this.dataDataOutlet.telp = '';
                            this.dataDataOutlet.selectedkota = '';
                            this.dataDataOutlet.logourl = '';
                            this.dataDataOutlet.alamat = '';
                        }
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }
            },
            async gabungkanWorkshopExisting(idworkshop) {
                this.dataProductionActivity.isClicked = true
                try {
                    const dataoutlet = new FormData
                    dataoutlet.append('nama_outlet', this.dataDataOutlet.nameOutlet)
                    dataoutlet.append('telp', this.dataDataOutlet.telp_code + this.dataDataOutlet.telp)
                    dataoutlet.append('alamat', this.dataDataOutlet.alamat)
                    dataoutlet.append('kota', this.dataDataOutlet.selectedkota)
                    dataoutlet.append('logo_url', this.dataDataOutlet.logourl)
                    dataoutlet.append('idowner', localStorage.getItem('idowner'))
                    dataoutlet.append('idworkshop', idworkshop)
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/create_outlet_with_exist_workshop', dataoutlet, this.requestHeaders, {
                            headers: {
                                'Content-Type': 'multipart/form-data'
                            }
                        }
                    )
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.skipOnboarding(1, res.data.data.idoutlet)
                            this.dataProductionActivity.isClicked = false
                            this.dataDataOutlet.nameOutlet = '';
                            this.dataDataOutlet.telp = '';
                            this.dataDataOutlet.selectedkota = '';
                            this.dataDataOutlet.logourl = '';
                            this.dataDataOutlet.alamat = '';
                        }
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }
            },
            async PostActivity() {
                if (!this.dataProductionActivity.checklisttahapan.includes(8000)) {
                    this.$toast.error("Tahpan Pengemasan wajib dicentang")

                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                    return
                }
                try {
                    const dataactivity = new FormData
                    dataactivity.append('idowner', localStorage.getItem('idowner'))
                    dataactivity.append('nama_outlet', this.dataDataOutlet.nameOutlet)
                    dataactivity.append('telp', this.dataDataOutlet.telp_code + this.dataDataOutlet.telp)
                    dataactivity.append('alamat', this.dataDataOutlet.alamat)
                    dataactivity.append('kota', this.dataDataOutlet.selectedkota)
                    dataactivity.append('logo_url', this.dataDataOutlet.logourl)
                    for (var i = 0; i < this.dataProductionActivity.checklisttahapan.length; i++) {
                        dataactivity.append('tahapan[]', this.dataProductionActivity.checklisttahapan[i])
                    }
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/create_outlet_workshop', dataactivity, this.requestHeaders);
                    if (res.status === 200) {
                        if (res.data.status === true) {
                            this.dataProductionActivity.isClicked = false;
                            this.dataDataOutlet.nameOutlet = '';
                            this.dataDataOutlet.telp = '';
                            this.dataDataOutlet.selectedkota = '';
                            this.dataDataOutlet.logourl = '';
                            this.dataProductionActivity.checklisttahapan = [];
                            this.clearDataAddOutlet()
                            this.skipOnboarding(1, res.data.data.idoutlet)
                            this.smartTrackingClick("simpan_outlet_gabung_workshop");

                        }
                        else {
                            this.handleErrorPost(res.data.msg)
                        }
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }
            },
            async PostActivityElse() {
                if (!this.dataProductionActivity.checklisttahapan.includes(8000)) {
                    this.$toast.error("Tahpan Pengemasan wajib dicentang")

                    this.dataProductionActivity.isClicked = false
                    $('#btnNext').prop('disabled', false);
                    $('#textBtn2').show();
                    return
                }
                try {
                    const dataplace = new FormData
                    dataplace.append('idowner', localStorage.getItem('idowner'))
                    dataplace.append('nama_outlet', this.dataDataOutlet.nameOutlet)
                    dataplace.append('telp', this.dataDataOutlet.telp_code + this.dataDataOutlet.telp)
                    dataplace.append('alamat', this.dataDataOutlet.alamat)
                    dataplace.append('kota', this.dataDataOutlet.selectedkota)
                    dataplace.append('logo_url', this.dataDataOutlet.logourl)
                    for (var i = 0; i < this.dataProductionActivity.checklisttahapan.length; i++) {
                        dataplace.append('tahapan[]', this.dataProductionActivity.checklisttahapan[i])
                    }
                    dataplace.append('kota_workshop', this.dataProductionPlace.selectedkota)
                    dataplace.append('telp_workshop', this.dataProductionPlace.telpworkshop)
                    dataplace.append('alamat_workshop', this.dataProductionPlace.alamatworkshop)
                    dataplace.append('nama_workshop', this.dataProductionPlace.namaworkshop)
                    const res = await this.$axios.post(this.$baseurl + '/masterData/outlet/create_outlet_seperate_workshop', dataplace, this.requestHeaders)
                    if (res.data.status === true) {
                        this.skipOnboarding(1, res.data.data.idoutlet)
                        this.clearDataAddOutlet()
                        this.dataProductionActivity.isClicked = false;
                        this.dataDataOutlet.nameOutlet = '';
                        this.dataDataOutlet.telp = '';
                        this.dataDataOutlet.selectedkota = '';
                        this.dataDataOutlet.logourl = '';
                        this.dataProductionPlace.selectedkota = '';
                        this.dataProductionPlace.telpworkshop = '';
                        this.dataProductionPlace.alamatworkshop = '';
                        this.dataProductionPlace.namaworkshop = '';
                        this.dataProductionActivity.checklisttahapan = [];
                        this.smartTrackingClick("simpan_outlet_terpisah_workshop");
                    } else {
                        this.handleErrorPost(res.data.msg)
                    }

                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }
            },
            handleErrorPost(msg) {
                this.$toast.error(msg)
                this.dataProductionActivity.isClicked = false
                $('#btnNext').prop('disabled', false);
                $('#textBtn2').show();
            },
            async skipOnboarding(params, data) {
                if (localStorage.getItem("step_walkthrough") === undefined || localStorage.getItem("step_walkthrough") === null || localStorage.getItem("step_walkthrough") === "0" || localStorage.getItem("step_walkthrough") === "") {
                    if (data != "") {
                        try {
                            const datawalkthrough = new FormData
                            datawalkthrough.append('walkthrough', params)
                            const response = await this.$axios.post(this.$baseurl + '/masterData/owner/update_status_walkthrough', datawalkthrough, this.requestHeaders);
                            if (response.data.code === 200) {
                                if (response.data.status === true) {
                                    localStorage.setItem("step_walkthrough", params)
                                    this.showdetailoutlet(data)
                                }
                            } else {
                                this.popupType = "error";
                                this.popupMessage = response.data.msg;
                            }
                        } catch (e) {
                            if (!e.code) {
                                this.popupType = "error";
                                this.popupErrorException = e;
                            }
                        }
                    } else {
                        this.showdetailoutlet(data)
                    }
                } else {
                    this.showdetailoutlet(data)
                }
            },
            async getTahapan() {
                try {
                    const response = await this.$axios.get(this.$baseurl + '/masterData/meta/tahapan_meta', this.requestHeaders)
                    if (response.status === 200) {
                        var rawtahapan = response.data.data
                        for (var i = 0; i < rawtahapan.length; i++) {
                            this.dataProductionActivity.dataTahapan.push({
                                idtahapan: rawtahapan[i].idtahapan,
                                text: rawtahapan[i].nama
                            })
                        }
                    }
                } catch (e) {
                    this.$catch_error_response(e)
                    this.dataProductionActivity.isClicked = false
                    $('#textBtn2').show();
                    $('#btnNext').prop('disabled', false);
                }
            },
            workshopToOutlet(idoutlet) {
                this.datalistoutlet.idoutlet = idoutlet

                this.isDataOutlet = false;
                this.isProductionProcess = false;
                this.isProductionActivity = false;
                this.isProductionPlace = false;
                this.isDetailOutlet = true;
                this.isHomeOutlet = false;
                this.isDataWorkshop = false;
                this.isProductionWorkshop = false;
                this.isDetailWorkshop = false;
                this.isSetTahapanWorkshop = false;
                $('#homeoutletworkshop').hide();
            },

            clearDataAddOutlet() {
                this.dataDataOutlet = {
                    selectedkota: '',
                    optionskota: [],
                    nameOutlet: '',
                    isClicked: false,
                    alamat: '',
                    telp: '',
                    logourl: '',
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }
                }

                this.dataProductionActivity.checklisttahapan = [8000]
                this.dataProductionActivity.isClicked = false

                this.dataPoductionProses = {
                    isClicked: false,
                    inputradio: '',
                }

                this.dataProductionActivity.checklisttahapan = [8000]
                this.pilih_jenisOutlet = ""
                this.dataPoductionProses = {
                    isClicked: false,
                    inputradio: '',
                }

                this.dataProductionPlace = {
                    selectedkota: '',
                    optionskota: [],
                    namaworkshop: '',
                    alamatworkshop: '',
                    telpworkshop: '',
                    isClicked: false,
                    requestHeaders: {
                        headers: {
                            'Authorization': 'Bearer ' + localStorage.getItem('token'),
                        }
                    }

                }
            },
            clearDataAddWorkshop() {
                this.dataDataWorkshop = {
                    telp: '',
                    selectedkota: '',
                    optionskota: [],
                    Alamat: '',
                    nama: '',

                }
                this.dataProductionWorkshop = {
                    dataTahapan: [],
                    checklisttahapan: [8000],
                    isClicked: false,
                }
            },
        },
    }
</script>

<style scoped>
    .hidesection {
        display: none;
    }

</style>